var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1086_8357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.02503 0.0531425C4.36618 0.349959 1.71669 2.5011 1.60734 5.57394C1.5386 7.45013 2.07131 8.85767 3.8569 9.25291C4.63175 7.88599 3.60695 7.58448 3.44761 6.59561C2.79304 2.54328 8.1217 -0.220242 10.9102 2.60889C12.8395 4.56789 11.5695 10.5948 8.45757 9.96839C5.4769 9.37007 9.91666 4.57257 7.53743 3.63057C5.60344 2.86509 4.57551 5.9723 5.49252 7.51575C4.95512 10.1699 3.79754 12.671 4.2662 16C5.78621 14.8971 6.29861 12.785 6.71884 10.5823C7.48276 11.0463 7.89049 11.529 8.8653 11.604C12.4599 11.8821 14.4673 8.01565 13.9768 4.44916C13.541 1.28728 10.3853 -0.321784 7.02503 0.0531425Z",
    fill: "#5F6C72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1086_8357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/Pinterest.83aa7b78b2362e7ab31c46823a2310cc.svg";
export { ForwardRef as ReactComponent };